import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Popover, Avatar, ButtonBase } from '@material-ui/core/';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import headerIcon from '../../../static/images/header.png';
import { DropDownIcon, DischgIcon, HospitalIcon, WardIcon, Support } from '../../Icon';
import { classNames, onKeyUpEnterOrSpace, updateWpLoginLocalStorage } from '../../../utils';
import {
  changeLanguageAction,
  updateLoginInfoAction,
  updateWardinfoAction,
  SetUnEdit,
  expiryLoginPopUpClose,
} from '../../../redux/actions';
import { LOGIN_INFO, USER_CURRENT_LANG, WARD_INFO } from '../../../comm/constant';
import { userRoleList } from '../../../utils/userRole';
import { updateUserRoleAction } from '../../../redux/actions/userRole';
import { addLoginAction, expiryLoginCancel } from '../../../utils/check';
import { authNameE } from '../../../utils/userFuncs';
import { LANGUAGE_EN_US, LANGUAGE_ZH_HK } from '../../../comm/config';
import { i18n, loadTranslations } from '../../../language';
import { hospitalWardListFunc } from '../../../utils/hospitalWardList';
import Dialog from '../../Dialog';
import { LoginPop, ExpiryLoginPop } from '../../Login';
import { envFunc } from '../../../utils/environments';
import rou from '../../../router';
import { mutationUpdateOtherLoginInfo } from '../../../utils/handleUpdateOtherLoginInfo';
import SystemDisplayMessage from '../../SystemDisplayMessage';
import SelectWardPop from './SelectWardPop';
import NotificationTotal from './NotificationTotal';
import AppreciationTotal from './AppreciationTotal';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    left: '6.25rem',
    right: 0,
    top: 0,
    height: '4.375rem',
    padding: '0 3.125rem 0 3.437rem',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    zIndex: '998',
    boxShadow: '0 0 0.75rem 0 #d2d7e0',
  },
  bitmap: {
    width: '7.75rem',
    height: '3.625rem',
    margin: '0.375.rem 3.375rem 0.375rem 0',
  },
  right: {
    display: 'flex',
  },
  oval: {
    width: '2.813rem',
    height: '2.813rem',
    border: 'solid 1px #ffffff',
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
    marginRight: '1.875rem',
  },
  ovalInfo: {
    minWidth: '10.625rem',
    color: theme.palette.font.main,
  },
  ward: {
    fontSize: '0.875rem',
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
  },
  haspital: {
    fontSize: '0.813rem',
    fontWeight: 'bold',
  },
  title: {
    margin: '0.813rem 1rem 0.75rem auto',
    width: '13rem',
    height: '2.813rem',
  },
  icon: {
    height: '2.813rem',
    width: '2.813rem',
    float: 'left',
    backgroundColor: 'blue',
  },
  top: {
    float: 'left',
    marginLeft: '0.875rem',
    marginTop: '0.25rem',
    fontSize: '0.875rem',
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
  },
  down: {
    float: 'left',
    marginLeft: '0.875rem',
    fontSize: '0.813rem',
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
    fontWeight: 'bold',
  },
  languages: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '3.938rem',
  },
  language: {
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '1.875rem',
    fontFamily: 'NotoSans-Bold',
  },
  choose: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  nochoose: {
    color: theme.palette.font.main,
  },
  dropdown: {
    width: '1.5rem',
    height: '1.5rem',
    cursor: 'pointer',
    padding: '0.5rem 1rem',
  },
  dropdownIcon: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
  popover: {
    '& .MuiPopover-paper': {
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '68%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '68%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  dropBody: {
    borderRadius: '2.7px',
    boxShadow: '0 0 16px 0 rgba(125, 134, 169, 0.2)',
  },
  dropItem: {
    height: '3.688rem',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    cursor: 'pointer',
    padding: '0 1.5rem',
    borderBottom: 'solid 1px #e4e7eb',
    whiteSpace: 'nowrap',
  },
  dropIcon: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.938rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dischgIcon: {
    fontSize: '1rem',
    color: theme.palette.font.main,
  },
  wardIcon: {
    fontSize: '1.25rem',
    color: theme.palette.font.main,
  },
  supportBox: {
    marginLeft: '1.875rem',
    width: '2.813rem',
    height: '2.813rem',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1.875rem',
  },
  supportIcon: {
    color: theme.palette.font.white,
    fontSize: '1.5rem',
  },
  loginBtn: {
    padding: '1rem',
    height: '3rem',
    marginRight: '1.5rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  resetImg: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.938rem',
  },
}));
function Header({
  changeLanguage,
  language,
  wardInfo,
  history,
  notificationTotal,
  expiryLogin,
  expiryLoginPopUpClose,
  roleMap,
  loginInfo,
  appreciationTotal
}) {
  const classes = useStyles();
  const [envLabel, setEnvLabel] = useState('');
  const sso = useSelector((state) => state.ssoReducer);

  const changeLanguageHandle = async (val) => {
    localStorage.setItem(USER_CURRENT_LANG, val);
    await loadTranslations(val);
    changeLanguage(val);
  };

  const handleNotifyOnClick = () => {
    history.push(rou.notificationRou.path);
  };

  const handleAppreciationOnClick = () => {
    history.push(rou.patientSurveyRou.path);
  }

  useEffect(() => {
    (async () => {
      setEnvLabel(await envFunc.getEnvLabel());
    })();
  }, []);

  return (
    <>
      {expiryLogin.isOpen ? (
        <ExpiryLoginPop
          open={expiryLogin.isOpen}
          submitHandle={expiryLoginPopUpClose}
          closeHandle={expiryLoginCancel}
        />
      ) : (
        ''
      )}

      {!sso && (
        <div
          className={classes.root}
          style={wardInfo.flag ? { paddingRight: '3.125rem' } : { paddingRight: '4.625rem' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={headerIcon} className={classes.bitmap} alt="" />
            <span style={{ color: 'red', fontSize: '32px' }}>{envLabel}</span>
          </div>
          <div
            style={{
              display: 'flex',
              height: 'inherit',
              flexGrow: 1,
              marginRight: '0.5rem',
            }}
          >
            <SystemDisplayMessage
              displayKey="HEADER_MSG"
              language={language}
              hospitalId={loginInfo?.hospitalId}
              wardId={loginInfo?.wardId}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={classes.languages}>
              <div
                className={
                  language === LANGUAGE_EN_US
                    ? classNames(classes.language, classes.choose)
                    : classNames(classes.language, classes.nochoose)
                }
                id="language_zh"
                onClick={() => {
                  (async () => {
                    await changeLanguageHandle(LANGUAGE_ZH_HK);
                  })();
                }}
                tabIndex={0}
                onKeyUp={(e) =>
                  onKeyUpEnterOrSpace(e, () => {
                    (async () => {
                      await changeLanguageHandle(LANGUAGE_ZH_HK);
                    })();
                  })
                }
              >
                繁
              </div>
              <div className={classes.language}>|</div>
              <div
                className={
                  language === LANGUAGE_ZH_HK
                    ? classNames(classes.language, classes.choose)
                    : classNames(classes.language, classes.nochoose)
                }
                id="language_en"
                onClick={() => {
                  (async () => {
                    await changeLanguageHandle(LANGUAGE_EN_US);
                  })();
                }}
                tabIndex={0}
                onKeyUp={(e) =>
                  onKeyUpEnterOrSpace(e, () => {
                    (async () => {
                      await changeLanguageHandle(LANGUAGE_EN_US);
                    })();
                  })
                }
              >
                EN
              </div>
            </div>
            <ButtonBase
              id="header_support_btn"
              className={classes.supportBox}
              onClick={() => {
                (async () => {
                  const supprtURL = await envFunc.getEnvLoginUrl();
                  setTimeout(() => {
                    window.open(supprtURL);
                  }, 300);
                })();
              }}
            >
              <Support className={classes.supportIcon} />
            </ButtonBase>
            <UserInfo>
              {roleMap[authNameE.patient_survey] && (
                <AppreciationTotal total={appreciationTotal} onClick={handleAppreciationOnClick} />
              )}
              {roleMap[authNameE.notification] && (
                <NotificationTotal total={notificationTotal} onClick={handleNotifyOnClick} />
              )}
            </UserInfo>
          </div>
        </div>
      )}
    </>
  );
}

export const UserInfo = ({ children }) => {
  const classes = useStyles();
  const { loginInfo, wardInfo, userRole, hospitalWardList, dutyEditFlag } = useSelector((state) => state);
  const [isShowLoginPop, setIsShowLoginPop] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dutyLeaveOpen, setDutyLeaveOpen] = useState(false);
  const [isSelectWardPop, setIsSelectWardPop] = useState(false);
  const dispatch = useDispatch();

  const closeLoginPop = () => {
    setIsShowLoginPop(false);
  };
  const showLoginPop = () => {
    setIsShowLoginPop(true);
  };

  const handleCancel = () => {
    setDutyLeaveOpen(false);
    setAnchorEl(null);
  };

  const handleConfirm = () => {
    setDutyLeaveOpen(false);
  };

  const hospWard = useMemo(() => {
    if (loginInfo.flag) {
      return userRoleList.getDetailFormat(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
    } else {
      return hospitalWardListFunc.getDetailFormat(hospitalWardList, wardInfo.hospitalId, wardInfo.wardId);
    }
  }, [loginInfo, wardInfo, userRole, hospitalWardList]);

  const showSelectWardPop = () => {
    setIsSelectWardPop(true);
    setAnchorEl(null);
  };

  const wardName = hospWard.wardName ? `${hospWard.wardName}` : '';
  const roleName = hospWard.roleName ? `,${hospWard.roleName}` : '';
  const displayWardInfo = `${wardName}${roleName}`;

  const handleLogout = () => {
    setAnchorEl(null);
    localStorage.removeItem(LOGIN_INFO);
    mutationUpdateOtherLoginInfo();
    const wardinfo = JSON.parse(localStorage.getItem(WARD_INFO));
    dispatch(updateLoginInfoAction({ flag: false, ...wardinfo }));
    addLoginAction();
    dispatch(SetUnEdit());
  };

  const closeSelectWardPop = () => {
    setIsSelectWardPop(false);
  };

  const handleChangeWard = ({ roleId: rId, wardId: wId }, userRoleData) => {
    const wardItem = userRoleList.getHospWardFormatUseRoleIdAndWardId(userRoleData, rId, wId);
    const { wardId, wardName, hospitalId, hospitalName, userId } = wardItem;
    setAnchorEl(null);
    updateWpLoginLocalStorage(wardName, wardId, hospitalId, hospitalName, userId);
    dispatch(updateLoginInfoAction({ ...loginInfo, wardId, wardName, hospitalId, hospitalName, userId }));
    addLoginAction();
    dispatch(SetUnEdit());
  };

  return (
    <>
      <div className={classes.right}>
        {children}
        {!loginInfo.flag && (
          <ButtonBase id="header_login_btn" className={classes.loginBtn} onClick={showLoginPop}>
            {i18n.t('LOGIN_TITLE')}
          </ButtonBase>
        )}
        <div
          className={classes.ovalInfo}
          onClick={loginInfo.flag ? () => { } : showLoginPop}
          tabIndex={0}
          onKeyUp={(e) => onKeyUpEnterOrSpace(e, loginInfo.flag ? () => { } : showLoginPop)}
        >
          {loginInfo.flag ? <Typography className={classes.ward}>{loginInfo.displayName ?? ''}</Typography> : null}
          <Typography className={classes.ward}>{displayWardInfo}</Typography>
          <Typography className={classes.haspital}>{hospWard.hospitalName ?? ''}</Typography>
        </div>
      </div>

      {/* Popups */}
      {isShowLoginPop && <LoginPop closehandle={closeLoginPop} submitHandle={closeLoginPop} />}
      {loginInfo.flag && (
        <div
          id="header_dropdown"
          className={classes.dropdown}
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
            if (dutyEditFlag) {
              setDutyLeaveOpen(true);
            }
          }}
          tabIndex={0}
          onKeyUp={(e) =>
            onKeyUpEnterOrSpace(e, (event) => {
              setAnchorEl(event.currentTarget);
              if (dutyEditFlag) {
                setDutyLeaveOpen(true);
              }
            })
          }
        >
          <DropDownIcon className={classes.dropdownIcon} />
        </div>
      )}
      {loginInfo.flag && (
        <Popover
          open={Boolean(anchorEl) && !dutyLeaveOpen}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          className={classes.popover}
        >
          <div className={classes.dropBody}>
            {!userRoleList.isSuperAdmin(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId) && (
              // _.map(wardList, (item, index) => (
              //   <div className={classes.dropItem} onClick={() => handleChangeWard(item)} key={index}>
              //     <div className={classes.dropIcon}>
              //       <WardIcon className={classes.wardIcon} />
              //     </div>
              //     {item.wardName}
              //   </div>
              // ))
              <div
                id="header_select_ward"
                className={classes.dropItem}
                onClick={showSelectWardPop}
                tabIndex={0}
                onKeyUp={(e) => onKeyUpEnterOrSpace(e, showSelectWardPop)}
              >
                <div className={classes.dropIcon}>
                  <WardIcon className={classes.wardIcon} />
                </div>
                {i18n.t('SETTING_SELECT_WARD')}
              </div>
            )}
            <div
              id="header_logout_btn"
              className={classes.dropItem}
              onClick={() => handleLogout()}
              tabIndex={0}
              onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => handleLogout())}
            >
              <div className={classes.dropIcon}>
                <DischgIcon className={classes.dischgIcon} />
              </div>
              {i18n.t('LOGIN_LOG_OUT')}
            </div>
          </div>
        </Popover>
      )}
      <Dialog
        open={dutyLeaveOpen}
        handleClose={handleCancel}
        handleCancel={handleCancel}
        title={i18n.t('DUTYASSIGN_NOT_SAVE_TITLE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-header-leave-page-cancel"
        confirmID="DutyAssign-header-leave-page-confirm"
        closeID="DutyAssign-header-leave-page-close"
        handleConfirm={handleConfirm}
      >
        <div
          style={{
            color: '#2e4469',
            fontSize: '1.25rem',
            fontFamily: 'NotoSans-Medium',
            fontWeight: 500,
            lineHeight: '1.875rem',
          }}
        >
          {i18n.t('DUTYASSIGN_NOT_SAVE_BODY')}
        </div>
      </Dialog>
      {isSelectWardPop && (
        <SelectWardPop open={isSelectWardPop} closePop={closeSelectWardPop} confirmClick={handleChangeWard} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  wardInfo: state.wardInfo,
  language: state.settings.language || LANGUAGE_EN_US,
  rouList: state.rouList,
  notificationTotal: state.notificationTotal,
  expiryLogin: state.expiryLogin,
  roleMap: state.roleMap,
  loginInfo: state.loginInfo,
  appreciationTotal: state.appreciationTotal
});

const mapDispatchToProps = (dispatch) => ({
  changeLanguage: (language) => {
    dispatch(changeLanguageAction(language));
  },
  updateWardinfo: ({ flag, hospitalName, wardName, wardId, hospitalId }) => {
    dispatch(updateWardinfoAction(flag, hospitalName, wardName, hospitalId, wardId));
  },
  updateUserRole: (data) => {
    dispatch(updateUserRoleAction(data));
  },
  expiryLoginPopUpClose: () => {
    dispatch(expiryLoginPopUpClose());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
